import React from "react";
import EmailLayout from '../EmailLayout';
import EmailLayoutWidget from './EmailLayoutWidget';
import { Utils, resolveEmailLayoutPreviewText, apply_email_links_color } from '../../services';
import { email_widget_wrapper_style } from './emailWidgetPreviewStyle';

/** Class representing a PDF layout custom text widget. */
class CustomTextWidget extends EmailLayoutWidget {

    constructor(properties) {
        super({
            ...(CustomTextWidget.getDefaultOptions()),
            ...properties,
        });

        this.type    = EmailLayout.TEXT;
        this.subType = EmailLayout.CUSTOM;
    }

    /**
     * Get this widget default options
     */
    static getDefaultOptions() {
        const textProperties = {};

        return {
            options: {
                text: textProperties,
                style: {
                    color: '#000000',
                    backgroundColor: '#FFFFFFFF',
                    borderStyle: 'solid',
                    borderWidth: 0,
                    borderColor: '#000000',
                    borderRadius: 0,
                    padding: {
                        top: 10,
                        right: 10,
                        bottom: 10,
                        left: 10,
                    },
                }
            }
        };
    }

    /**
     * Return the list of options this widget handles
     */
    getHandledOptions() {
        return super.getHandledOptions().concat([
            EmailLayout.OPTION_COLOR,
            EmailLayout.OPTION_LINKS_COLOR,
            EmailLayout.OPTION_TEXT,
            EmailLayout.OPTION_PADDING,
        ]);
    }

    /**
     * Return this widget preview text as string
     *
     * @param {Object} props with at least the following properties:
     *                 - {Bool} inEdition
     *                 - {String} lang
     *                 - {Object} setting
     */
    getPreviewText(props) {
        const { inEdition, lang, setting, preview_context, tickettype } = props;
        const raw = Utils.localized_or_fallback(this.options?.text, lang, '')
            || (inEdition ? '.....' : '');
        return resolveEmailLayoutPreviewText(raw, {
            context: preview_context,
            setting,
            tickettype,
            lang,
            inEdition,
        });
    }

    /**
     * Return this widget preview as JSX string
     *
     * @param {Object} props with at least the following properties:
     *                 - {EmailLayout} layout
     *                 - {Bool} inEdition
     *                 - {String} lang
     *                 - {Object} setting
     */
    getPreview(props) {
        const links_color = this.options?.style?.linksColor;
        const text_color = this.options?.style?.color || '#000000';
        let __html = this.getPreviewText(props);
        if (links_color)
            __html = apply_email_links_color(__html, links_color, text_color);
        const wrapper_style = {
            ...email_widget_wrapper_style(this.options?.style),
            color: text_color,
        };
        if (links_color)
            wrapper_style['--email-links-color'] = links_color;
        return (
            <div
                className={links_color ? 'email-custom-text-widget has-links-color' : 'email-custom-text-widget'}
                style={wrapper_style}
            >
                <div className={this.id} dangerouslySetInnerHTML={{ __html }} />
            </div>
        );
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'commenting-o';
    }
}

export default CustomTextWidget;
